import type { ListBuilderList } from '../../../types';
import { BASE_FILTER_RULES, TRANSACTION_REQUIRED_FIELDS } from '../shared';

/**
 * Failed transactions list - inherits from all-transactions with status filter
 */
export const failedTransactionsList: ListBuilderList = {
	id: 'default-transaction-failed',
	inheritsFrom: 'default-transaction-all',
	cacheTTL: 300000,
	name: 'Failed Transactions',
	type: 'default',
	active: true,
	sortOrder: 2,
	description: 'Failed transactions only',
	defaultSortId: 'column-transaction-dates-asc',
	requiredFields: TRANSACTION_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		transactionStatus: {
			defaultValue: [{ id: 'Failed', label: 'Failed' }],
		},
	},
};
